module.exports = __webpack_public_path__ + "img/img36.280ceb12.svg";